import React, { Component } from "react"
import ContactForm from "../Contact-Form/index"

class ContactFormSection extends Component {
  render() {
    return (
      <section id="contact-form-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 pr-md-5">
              <header className="section-header">
                <h2>Get in Touch</h2>
                <p className="text-left mt-4">
                  All users on Morosoft will know that there are millions of
                  people out there. Every day besides so many people joining
                  this community.
                </p>

                <div className="row contact-location-row mt-5">
                  <div className="col-12">
                    <p className=" mb-0 text-left">
                      Office S#16, E-8 Markaz Plaza, <br /> Hyderi Chowk,
                      Saidpur Road, Rawalpindi
                    </p>
                  </div>
                </div>

                <div className="row contact-phone-row mt-5">
                  <div className="col-12">
                    <p className=" mb-0 text-left">
                      <strong>Call us on:</strong>
                      <br />
                      <a className="contact-link" href="tel:+92 334 3868945">
                        +92 334 3868945
                      </a>
                    </p>
                  </div>
                </div>

                <div className="row contact-email-row mt-5">
                  <div className="col-12">
                    <p className=" mb-0 text-left">
                      <strong>Email us on:</strong>
                      <br />
                      <a
                        className="contact-link"
                        href="mailto:info@morosoft.org"
                      >
                        info@morosoft.org
                      </a>
                    </p>
                  </div>
                </div>
              </header>
            </div>

            <div className="col-lg-6 col-md-12 p-md-5 contact-form-col">
              <h3 className="my-h3-head mb-md-4">Drop Your Message</h3>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default ContactFormSection
